import { render, staticRenderFns } from "./PazienteEventoIcdIxComponent.vue?vue&type=template&id=3386377e"
import script from "./PazienteEventoIcdIxComponent.vue?vue&type=script&lang=js"
export * from "./PazienteEventoIcdIxComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports